// 請求明細一覧内の定数

export const 車輌Bindings = ["車番", "トレーラ車番", "乗務員名", "運行部所名"]
export const 積卸地Bindings = ["積場社名", "積場地名", "卸場社名", "卸場地名"]

export const 品名Bindings = ["品コード", "品名", "数量", "単位区分名称"]

export const 請求Bindings = [
  "荷主請求内訳ID",
  "請求区分名称",
  "請求車番",
  "単価",
  "履歴検索",
  "タリフ検索",
  "請求運送料課税区分コード",
  "運送料",
  "請求付帯料課税区分コード",
  "付帯料",
  "請求高速料",
  "請求額合計",
  "請求備考",
  "計上基準日区分名称",
  "請求計上日",
  "請求額確認区分コード",
]
